<template>
    <div class="container">
        <div class="content-box">
          <div class="element-wrapper pb-0">
            <h3 class="element-header">Usuários atendentes</h3>
            <div class="element-box">
                <h5 class="form-header">Gerenciar Usuários atendentes da sua Unidade</h5>
                <div class="form-desc" style="margin-botton: 0;">Realize o cadastro, edição, ativação, desativação e alteração de senha dos Funcionários da sua Unidade.</div>
            </div>
          </div>
          
              <div class="element-wrapper">
                <div class="element-actions">
                  <a class="btn btn-warning" @click="novo()">
                    <i class="fa fa-file"></i> <span>Novo</span>
                  </a>
                </div>
                <div class="element-box-tp">
                <div class="table-responsive">
                    <table class="table table-padded">
                    <thead>
                        <tr>
                          <th>CPF</th>
                          <th>User name</th>
                          <th>Nome</th>
                          <th class="text-center">
                              Celular
                          </th>
                          <th class="text-center">
                              Status
                          </th>
                          <th>
                          </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="usuario in usuarios" :key="usuario._id">
                        <td>
                            <span>{{ usuario.cpf }}</span>
                        </td>
                        <td>{{ usuario.username }}</td>
                        <td>
                            <span>
                            {{ usuario.name }}
                            </span>
                        </td>
                        <td>
                            <span class="smaller lighter">{{ usuario.telefoneCelular }}</span>
                        </td>
                        <td class="nowrap">
                            <span class="status-pill smaller"
                              :class="{'green': usuario.status === 'Habilitado', 'red': usuario.status === 'Desabilitado'}"></span><span>{{ usuario.status }}</span>
                        </td>
                        <td class="row-actions text-center">
                          <a class="btn btn-info" role="button"
                            title="Editar"
                            @click="editar(usuario)">
                            <i class="fa fa-edit"></i>
                          </a>
                          <a v-if="usuario.status !== 'Habilitado'" class="btn btn-info" role="button"
                            title="Ativar"
                            @click="ativar(usuario)">
                            <i class="fa fa-thumbs-up"></i>
                          </a>
                          <a v-else class="btn btn-info" role="button"
                            title="Desativar"
                            @click="desativar(usuario)">
                            <i class="fa fa-thumbs-down"></i>
                          </a>
                        </td>
                        </tr>

                    </tbody>
                    </table>
                </div>
                </div>
            </div>
          </div>
      
  <!-- Modal -->
  <div class="modal fade" id="modalUsrForm" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="modelTitleId">Cadastro Atendente</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col">
              <div class="form-group" :class="{'has-danger': errors.has('nome')}">
                <label for="nome">Nome</label>
                <input autofocus v-model="userForm.nome" id="nome" name="nome" type="text" 
                  class="form-control"
                  v-validate="'required'">
                <div v-if="errors.has('nome')" class="help-block form-text text-muted form-control-feedback">
                  {{errors.first('nome')}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group" :class="{'has-danger': errors.has('cpf')}">
                <label for="cpf">CPF</label>
                <input v-model="userForm.cpf" id="cpf" name="cpf"
                  v-mask="'###.###.###-##'" type="tel" 
                  v-validate="'required'"
                  class="form-control">
                <div v-if="errors.has('cpf')" class="help-block form-text text-muted form-control-feedback">
                  {{errors.first('cpf')}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group" :class="{'has-danger': errors.has('telefone')}">
                <label for="telefone">Celular</label>
                <input v-model="userForm.telefone"
                  id="telefone"  name="telefone"
                  v-mask="['(##) ####-####', '(##) #####-####']"
                  type="tel" class="form-control">
                <div v-if="errors.has('telefone')" class="help-block form-text text-muted form-control-feedback">
                  {{errors.first('telefone')}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group" :class="{'has-danger': errors.has('email')}">
                <label for="email">Email</label>
                <input v-model="userForm.email" 
                  id="email" name="email" type="email" 
                  v-validate="'required|email'"
                  class="form-control">
                <div v-if="errors.has('email')" class="help-block form-text text-muted form-control-feedback">
                  {{errors.first('email')}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group" :class="{'has-danger': errors.has('username')}">
                <label for="username">Username</label>
                <input v-model="userForm.username" type="text" class="form-control"
                  id="username" name="username"
                  v-validate="'required'">
                <div v-if="errors.has('username')" class="help-block form-text text-muted form-control-feedback">
                  {{errors.first('username')}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group" :class="{'has-danger': errors.has('password')}">
                <label for="username">Senha</label>
                <input v-model="userForm.password" type="password" class="form-control"
                  id="password" name="password"
                  v-validate="'required'">
                <div v-if="errors.has('password')" class="help-block form-text text-muted form-control-feedback">
                  {{errors.first('password')}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
          <button @click="salvar" type="button" class="btn btn-primary">Salvar</button>
        </div>
      </div>
    </div>
  </div>

    </div>
</template>
<script>
import * as http from 'axios'

export default {
  computed: {
    rede () {
      return this.$store.getters.rede
    }
  },
  data () {
    return {
      usuarios: [],
      userForm: {
        cpf: '',
        nome: '',
        email: '',
        dataNascimento: '',
        telefone: '',
        password: ''
      }
    }
  },
  async created () {
    this.listAll()
  },
  methods: {
    async listAll () {
      let userResponse = await http.get(`/usuario?rede=${this.rede._id}&role__in=ATENDENTE`)
      this.$store.dispatch('setLoading', false)
      this.usuarios = userResponse.data
    },
    novo () {
      this.userForm = {
        cpf: '',
        nome: '',
        email: '',
        dataNascimento: '',
        telefone: ''
      }
      this.$validator.reset()
      this.$nextTick(() => {
        window.jQuery('#modalUsrForm').modal('show')
      })
    },
    async salvar () {
      this.$validator.validateAll()
        .then(async (result) => {
          if (result) {
            let usr = {
              username: this.userForm.username,
              name: this.userForm.nome,
              email: this.userForm.email,
              cpf: this.userForm.cpf,
              password: this.userForm.password,
              rede: this.rede,
              role: 'ATENDENTE',
              telefoneCelular: this.userForm.telefone,
              status: 'Habilitado'
            }

            if (this.userForm.id) {
              usr._id = this.userForm.id
              await http.put(`/usuario/${this.userForm.id}`, usr)
            } else {
              await http.post('/usuario', usr)
            }

            this.$nextTick(() => {
              window.jQuery('#modalUsrForm').modal('hide')
            })

            await this.listAll()
          }
        })
    },
    editar (usuario) {
      this.userForm.id = usuario._id
      this.userForm.nome = usuario.name
      this.userForm.cpf = usuario.cpf
      this.userForm.email = usuario.email
      this.userForm.telefone = usuario.telefoneCelular
      this.userForm.username = usuario.username
      this.$nextTick(() => {
        window.jQuery('#modalUsrForm').modal('show')
      })
    },
    async ativar (usuario) {
      usuario.status = 'Habilitado'
      await http.put(`/usuario/${usuario._id}`, usuario)
      await this.listAll()
    },
    async desativar (usuario) {
      usuario.status = 'Desabilitado'
      await http.put(`/usuario/${usuario._id}`, usuario)
      await this.listAll()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/usuarioAtendente/UsuarioAtendente.vue